import './polyfills';
import { Application } from '@hotwired/stimulus';
import { getMetaValue } from './utilities/browser';
import BlockAsyncController from './controllers/block-async-controller';
import PasswordController from './controllers/password-controller';
import CheckboxToggleController from './controllers/checkbox-toggle-controller';
import SliderController from './controllers/slider-controller';
import GlobalController from './controllers/global-controller';
import SelectController from './controllers/select-controller';
import SidebarFilterController from './controllers/sidebar-filter-controller';
import CalendarController from './controllers/calendar-controller';
import QuantityController from './controllers/quantity-controller';
import FloatingCartController from './controllers/floating-cart-controller';
import GroupSelectController from './controllers/group-select-controller';
import ModalController from './controllers/modal-controller';
import DatepickerController from './controllers/datepicker-controller';
import FormController from './controllers/form-controller';
import DiaryCalendarController from './controllers/diary-calendar-controller';
import TabsController from './controllers/tabs-controller';
import PhoneController from './controllers/phone-controller';
import ContractPriceController from './controllers/contract-price-controller';
import ContractDocumentController from './controllers/contract-document-controller';
import QueueRepeaterController from "./controllers/queue-repeater-controller";
import CheckoutVisibilityController from "./controllers/checkout-visibility-controller";
import FileUploadController from "./controllers/file-upload-controller";
import ModalMessagesSelect from "./controllers/modal-messages-select-controller";
import ScrollPositionController from './controllers/scroll-position-controller';
import VacationDateController from './controllers/vacation-date-controller';
import MessagesMyListController from './controllers/messages-my-list-controller';
import ConsentContentController from './controllers/consent-content-controller';
import LoginRedirectController from './controllers/login-redirect-controller';
import SearchInputController from './controllers/search-input-controller';
import ForLeadersAttendanceController from './controllers/for-leaders-attendance-controller';
import CheckoutController from './controllers/checkout-controller';
import CouponPriceController from './controllers/coupon-price-controller';
import SignatureController from './controllers/signature-controller';
import InvoicesController from './controllers/invoices-controller';
import DatasetSearchController from './controllers/dataset-search-controller';
import StickyFooterController from './controllers/sticky-footer-controller';
import TimetableController from './controllers/timetable-controller';
import PdfController from './controllers/pdf-controller';
import TimetableTooltipController from './controllers/timetable-tooltip-controller';
import CopyController from './controllers/copy-controller';
import ReviewsController from './controllers/reviews-controller';
import GrFormController from './controllers/gr-form-controller';
import GrHistoryController from './controllers/gr-history-controller';
import HeroPlanFilterController from './controllers/hero-plan-filter-controller';
import ProductPageController from './controllers/product-page-controller';
import FilterTooltipController from './controllers/filter-tooltip-controller';
import LightboxController from './controllers/lightbox-controller';
import WaitingListController from './controllers/waiting-list-controller';
import QueueRefreshController from './controllers/queue-refresh-controller';
import PromoCycleController from './controllers/promo-cycle-controller';
import ForgotPasswordController from './controllers/forgot-password-controller';
import CartRecommendationsController from './controllers/cart-recommendations-controller';
import CampFilterController from './controllers/camp-filter-controller';


// Set webpack public asset url
window.__webpack_public_path__ = getMetaValue('theme-url');

const application = Application.start();

application.register('block-async', BlockAsyncController);
application.register('global', GlobalController);
application.register('password', PasswordController);
application.register('checkbox-toggle', CheckboxToggleController);
application.register('slider', SliderController);
application.register('modal', ModalController);
application.register('select', SelectController);
application.register('sidebar-filter', SidebarFilterController);
application.register('group-select', GroupSelectController);
application.register('calendar', CalendarController);
application.register('checkout-visibility', CheckoutVisibilityController);
application.register('datepicker', DatepickerController);
application.register('quantity', QuantityController);
application.register('floating-cart', FloatingCartController);
application.register('form', FormController);
application.register('tabs', TabsController);
application.register('phone', PhoneController);
application.register('contract-price', ContractPriceController);
application.register('contract-document', ContractDocumentController);
application.register('queue-repeater', QueueRepeaterController);
application.register('file-upload', FileUploadController);
application.register('modal-messages-select', ModalMessagesSelect);
application.register("scroll-position", ScrollPositionController)
application.register("vacation-date", VacationDateController)
application.register("messages-my-list", MessagesMyListController)
application.register("consent-content", ConsentContentController)
application.register("login-redirect", LoginRedirectController)
application.register("search-input", SearchInputController)
application.register('diary-calendar', DiaryCalendarController);
application.register('for-leaders-attendance', ForLeadersAttendanceController);
application.register("checkout", CheckoutController)
application.register("coupon-price", CouponPriceController)
application.register("signature", SignatureController)
application.register("invoices", InvoicesController)
application.register("dataset-search", DatasetSearchController)
application.register("sticky-footer", StickyFooterController)
application.register("timetable", TimetableController)
application.register("pdf", PdfController)
application.register("timetable-tooltip", TimetableTooltipController)
application.register("filter-tooltip", FilterTooltipController)
application.register("copy", CopyController)
application.register("reviews", ReviewsController)
application.register("gr-form", GrFormController)
application.register("gr-history", GrHistoryController)
application.register('hero-plan-filter', HeroPlanFilterController);
application.register('product-page', ProductPageController);
application.register('filter-tooltip', FilterTooltipController);
application.register('lightbox', LightboxController);
application.register('waiting-list', WaitingListController);
application.register('queue-refresh', QueueRefreshController);
application.register('promo-cycle', PromoCycleController);
application.register('forgot-password', ForgotPasswordController);
application.register('cart-recommendations', CartRecommendationsController)
application.register('camp-filter', CampFilterController);

function getApplication() {
    return application;
}

export {
    getApplication,
};
